import React from "react";
import { Phone, MessageCircle } from "lucide-react";
import { Reveal } from "./Reveal";
import ContactForm from "./ContactForm";
import { ACADEMY, WHATSAPP_LINK } from "../../lib/constants";

// Dark contact call-to-action used on the Home page
export default function ContactCTA() {
  return (
    <section className="relative bg-purple grain py-24 md:py-32 overflow-hidden" data-testid="contact-cta">
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_20%_20%,rgba(212,175,55,0.14),transparent_50%)]" />
      <div className="relative rb-container grid lg:grid-cols-2 gap-16 items-center">
        <div>
          <Reveal>
            <p className="overline text-gold mb-5 flex items-center gap-3">
              <span className="h-px w-10 bg-gold inline-block" /> Begin Your Journey
            </p>
            <h2 className="font-serif font-light text-4xl md:text-5xl lg:text-6xl text-[#F6F4EE] leading-[1.02] tracking-tight">
              Your first step onto the stage starts here.
            </h2>
            <p className="mt-6 text-[#F6F4EE]/70 text-lg leading-relaxed max-w-md">
              Enquire about classes, timings and fees. Learn under {ACADEMY.master} at Rythmbara Dance Academy.
            </p>
          </Reveal>

          <Reveal delay={0.15}>
            <div className="mt-10 flex flex-wrap gap-4">
              <a href={`tel:${ACADEMY.phoneRaw}`} data-testid="cta-call" className="btn-outline-gold inline-flex items-center gap-2 px-7 py-3.5 text-sm font-semibold uppercase tracking-[0.15em]">
                <Phone className="h-4 w-4" /> {ACADEMY.phone}
              </a>
              <a href={WHATSAPP_LINK} target="_blank" rel="noopener noreferrer" data-testid="cta-whatsapp" className="btn-outline-gold inline-flex items-center gap-2 px-7 py-3.5 text-sm font-semibold uppercase tracking-[0.15em]">
                <MessageCircle className="h-4 w-4" /> WhatsApp
              </a>
            </div>
          </Reveal>
        </div>

        <Reveal delay={0.2} className="glass-dark p-8 md:p-10 border border-[rgba(212,175,55,0.2)]">
          <ContactForm dark />
        </Reveal>
      </div>
    </section>
  );
}
